/**
 * Pexels Image Block for Editor.js
 * 画像とクレジットを表示するカスタムブロック
 */
class PexelsImageBlock {
  static get toolbox() {
    return {
      title: 'Pexels Image',
      icon: '<svg width="17" height="15" viewBox="0 0 336 276" xmlns="http://www.w3.org/2000/svg"><path d="M291 150V79c0-19-15-34-34-34H79c-19 0-34 15-34 34v42l67-44 81 72 56-29 42 30zm0 52l-43-30-56 30-81-67-66 39v23c0 19 15 34 34 34h178c17 0 31-13 34-29zM79 0h178c44 0 79 35 79 79v118c0 44-35 79-79 79H79c-44 0-79-35-79-79V79C0 35 35 0 79 0z"/></svg>',
    };
  }

  static get isReadOnlySupported() {
    return true;
  }

  constructor({ data, api, readOnly }) {
    this.api = api;
    this.readOnly = readOnly;
    this.data = {
      url: data.url || '',
      alt: data.alt || '',
      photographer: data.photographer || '',
      photographer_url: data.photographer_url || '',
      markerId: data.markerId || `pexels-img-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
    };
    this.wrapper = null;
  }

  render() {
    this.wrapper = document.createElement('div');
    this.wrapper.classList.add('pexels-image-block');
    this.wrapper.style.cssText = 'margin: 16px 0; text-align: center; position: relative;';

    if (this.data.url) {
      const img = document.createElement('img');
      img.src = this.data.url;
      img.alt = this.data.alt;
      img.style.cssText = 'max-width: 100%; height: auto; display: block; margin: 0 auto;';
      this.wrapper.appendChild(img);

      if (this.data.photographer) {
        const creditWrapper = document.createElement('div');
        creditWrapper.style.cssText = 'position: relative; display: inline-block; margin-top: 8px;';
        
        const credit = document.createElement('small');
        credit.contentEditable = !this.readOnly;
        credit.style.cssText = 'display: block; text-align: center; color: #666; font-size: 12px;';
        credit.innerHTML = `Photo by <a href="${this.data.photographer_url}" target="_blank" rel="noopener noreferrer">${this.data.photographer}</a> on Pexels`;
        
        // 削除ボタン
        if (!this.readOnly) {
          const deleteBtn = document.createElement('button');
          deleteBtn.innerHTML = '×';
          deleteBtn.style.cssText = 'position: absolute; top: -5px; right: -20px; width: 18px; height: 18px; border-radius: 50%; border: 1px solid #d9d9d9; background: white; color: #999; cursor: pointer; font-size: 14px; line-height: 1; padding: 0;';
          deleteBtn.title = 'キャプションを削除';
          deleteBtn.onclick = (e) => {
            e.preventDefault();
            e.stopPropagation();
            creditWrapper.remove();
            this.data.photographer = '';
            this.data.photographer_url = '';
          };
          creditWrapper.appendChild(deleteBtn);
        }
        
        creditWrapper.appendChild(credit);
        this.wrapper.appendChild(creditWrapper);
      }
    } else {
      const placeholder = document.createElement('div');
      placeholder.textContent = '[Pexels Image Placeholder]';
      placeholder.style.cssText = 'padding: 40px; background: #f0f0f0; color: #999; text-align: center;';
      this.wrapper.appendChild(placeholder);
    }

    return this.wrapper;
  }

  save() {
    return {
      url: this.data.url,
      alt: this.data.alt,
      photographer: this.data.photographer,
      photographer_url: this.data.photographer_url,
      markerId: this.data.markerId,
    };
  }
}

export default PexelsImageBlock;

